interface IAssets {
    brandLogo: string
}

export const Assets: IAssets = {
    brandLogo: require('../assets/img/logo-filled.png')
};